<div class="page-content">
  <div *ngIf="loaded">
      <h1>{{'PROJECT.INITIAL.SCOPING_RESULTS' | anessaTranslation: trigger}}</h1>

      <!-- selects -->
      <div class="select-controls">
          <div class="select">
              <mat-form-field appearance="fill">
                  <mat-label>{{'PROJECT.INITIAL.SCOPING.SELECT_OPTION' | anessaTranslation: trigger}}</mat-label>
                  <mat-select [(value)]="selected" (selectionChange)="onSelectedChecklistChange()">
                      <mat-option *ngIf="scopingTestList" [value]="scopingTestList">{{scopingTestList.name}}</mat-option>
                      <mat-option *ngFor="let checklist of checklists" [value]="checklist">{{checklist.name}}</mat-option>
                  </mat-select>
              </mat-form-field>
          </div>
          <div class="select">
              <mat-form-field appearance="fill">
                  <mat-label>{{'PROJECT.INITIAL.SCOPING.SELECT_ROWS' | anessaTranslation: trigger}}</mat-label>
                  <mat-select [(value)]="selectedReportRows" (selectionChange)="onSelectedRowsChange()"
                      [disableRipple]="true"
                      [disabled]="selected == undefined || selected == null" [multiple]="true">
                      <ng-container *ngIf="selected">
                        <ng-container *ngFor="let row of flattenedRows">
                            <!-- Increase left padding according to the level of the row so it is indented under its parent -->
                            <mat-option [value]="row" [ngStyle]="{'padding-left': 10 * row.level + 'px'}">{{getNameForRow(row)}}</mat-option>
                        </ng-container>
                      </ng-container>
                  </mat-select>
              </mat-form-field>
          </div>
      </div>

  </div>
  <div id="checklist-modify-component-block" *ngIf="selected">
      <app-project-info-checklist-modify [isEmbedded]="true" [showTitle]="false" [checklistInput]="selected" [showSaveBtn]="true"
          (saved)="onSave($event)" (cancel)="onCancel()"></app-project-info-checklist-modify>
  </div>
  <div *ngIf="!loaded">
      <p>{{'PROJECT.INITIAL.SCOPING.NO_PROJECT_LOADED' | anessaTranslation: trigger}}</p>
  </div>


  <!-- checklist modify component -->
  <button mat-button color="primary" (click)="goBack()">{{'PROJECT.COMMON.GO_BACK' | anessaTranslation: trigger}}</button>
  <!-- <button mat-button color="primary" (click)="getIndicatorStatus()">getStatus</button> -->


  <div class="table-section" *ngIf="!selected">
    <div *ngIf="getDataSource(scopingTestList).length > 0">
      <h3>{{scopingTestList.name}}</h3>
      <table mat-table [dataSource]="getDataSource(scopingTestList)">
        <div *ngFor="let column of getListHeaders(scopingTestList);">
          <ng-container matColumnDef="{{column}}">
            <th mat-header-cell *matHeaderCellDef>
              {{column}}
            </th>
            <td mat-cell *matCellDef="let element">
              <span
                *ngIf="isColourHexCode(element[column]) else standardDisplay"
                class="coloured-circle"
                [ngStyle]="{'background-color': element[column]}">
              </span>
              <ng-template #standardDisplay>
                {{element[column]}}
              </ng-template>
            </td>
          </ng-container>
        </div>

        <tr mat-header-row *matHeaderRowDef="getListHeaders(scopingTestList)"></tr>
        <tr mat-row *matRowDef="let row; columns: getListHeaders(scopingTestList);"></tr>
      </table>
    </div>
    <div *ngFor="let list of checklists">
      <div *ngIf="getDataSource(list).length > 0">
        <h3>{{list.name}}</h3>
        <table mat-table [dataSource]="getDataSource(list)">
          <div *ngFor="let column of getListHeaders(list);">
            <ng-container matColumnDef="{{column}}">
              <th mat-header-cell *matHeaderCellDef>
                {{column}}
              </th>
              <td mat-cell *matCellDef="let element">
                <span
                  *ngIf="isColourHexCode(element[column]) else standardDisplay"
                  class="coloured-circle"
                  [ngStyle]="{'background-color': element[column]}">
                </span>
                <ng-template #standardDisplay>
                  {{element[column]}}
                </ng-template>
              </td>
            </ng-container>
          </div>

          <tr mat-header-row *matHeaderRowDef="getListHeaders(list)"></tr>
          <tr mat-row *matRowDef="let row; columns: getListHeaders(list);"></tr>
        </table>
      </div>
    </div>
  </div>
  <div class="center" *ngIf="isSavedProject">
    <button mat-button color="primary" (click)="getReport()">{{'PROJECT.INITIAL.SCOPING.ANESSA_GENERATED_REPORT_BTN' | anessaTranslation: trigger}}</button>
  </div>
</div>
